"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateDefault = void 0;
var tslib_1 = require("tslib");
var joi_1 = tslib_1.__importDefault(require("joi"));
var parse_date_json_def_1 = require("./parse.date.json.def");
exports.dateDefault = joi_1.default.alternatives(joi_1.default.string().isoDate().example('2023-01-12T05:14:02.887Z'), parse_date_json_def_1.parseDateJsonDef);
//# sourceMappingURL=types.def.js.map